import esriConfig from '@arcgis/core/config.js';
import { ConfigProvider } from 'antd';
import { rootStore, RootStoreProvider } from 'models/rootModel';
import moment from 'moment';
import 'moment/locale/sv';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { domPurifyOpenLinksInNewWindow } from 'utils/DomPurifyHooks';
import { getLanguage } from 'utils/locale';
import App from './app';

esriConfig.assetsPath = `${process.env.PUBLIC_URL}/assets`;

let baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
baseUrl = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;
const rootElement = document.getElementById('root');

domPurifyOpenLinksInNewWindow();

moment.locale('sv');

ReactDOM.render(
  <BrowserRouter basename={baseUrl}>
    <ConfigProvider locale={getLanguage()}>
      <RootStoreProvider value={rootStore}>
        <App />
      </RootStoreProvider>
    </ConfigProvider>
  </BrowserRouter>,
  rootElement
);
